import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'lex-run-production-dialog',
    templateUrl: './run-production-dialog.component.html',
    styleUrls: ['./run-production-dialog.component.scss'],
    standalone: false
})
export class RunProductionDialogComponent {

  notifyUser: boolean;

  constructor(private dialogRef: MatDialogRef<RunProductionDialogComponent>) { }

  run() {
    this.dialogRef.close({ isAddToQueue: true, isNotifyUser: this.notifyUser });
  }
}
